(function(angular) {
    angular.module('wtApp.dataService')
        .decorator('$q', function($delegate) {
            const defer = $delegate.defer;
            $delegate.defer = function() {
                const deferred = defer();
                const resolve_ = deferred.resolve;
                const reject_ = deferred.reject;
                deferred.promise.state = 'PENDING';
                deferred.state = 'PENDING';
                deferred.promise.then(function() {
                    deferred.promise.state = 'SUCCESS';
                    deferred.state = 'SUCCESS';
                }, function() {
                    deferred.promise.state = 'ERROR';
                    deferred.state = 'ERROR';
                });
                deferred.resolve = function(data) {
                    deferred.promise.state = 'SUCCESS';
                    deferred.state = 'SUCCESS';
                    return resolve_(data);
                };
                deferred.reject = function(data) {
                    deferred.promise.state = 'ERROR';
                    deferred.state = 'ERROR';
                    return reject_(data);
                };
                return deferred;
            };
            return $delegate;
        });
})(window.angular);
